<template>
  <v-card height="44">
    <v-card-text class="align-self-stretch">
      <v-row class="d-flex justify-space-between mt-n3">
        <v-btn icon class="d-flex my-auto ml-2" @click="gotoPrevWeek"><v-icon x-large>mdi-chevron-left</v-icon></v-btn>
        <div>
          <h6 class="d-flex body-1 mx-auto mt-2">{{woche}}</h6>
        </div>
        <v-btn icon class="d-flex my-auto mr-2" @click="gotoNextWeek" :disabled="disabledRight"><v-icon x-large>mdi-chevron-right</v-icon></v-btn>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>

import Kinds from "@/components/Kinds";

const {DateTime} = require("luxon");
import {round} from "@/reusable/numbers";
import Bereiche from "@/components/Bereiche";

export default {
  name: "WeekPaginator",
  components: { },
  props: ['date', 'nr', 'baseUrl'],
  data() {
    return {
      woche:"diese Woche",
      disabledRight:false,
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      if (!this.date)
        return;
      var dateTime=DateTime.local();
      if (this.date)
        dateTime=DateTime.fromJSDate(this.date);
      this.weekDate=dateTime.setLocale("de").startOf("week");
      var mo=this.weekDate;
      var so=this.weekDate.plus({'days':6});
      //console.log("index week: " + this.weekDate.toISODate())
      var today=DateTime.fromJSDate(new Date(Date.now()));
      //var today=DateTime.fromISO("2020-11-23")
      var diff=today.diff(this.weekDate, 'days').days;
      //console.log({diff, dateTime, today})
      if (diff < -1 || diff > 7)
        this.woche=`${mo.day}.${mo.month}. - ${so.day}.${so.month}.`;
      else
        this.woche="diese Woche"
      this.disabledRight=diff<6;
    },
    gotoPrevWeek() {
      var iso=this.weekDate.plus({ days: -7 }).toISODate();
      var url=(this.baseUrl)+iso;
      if (this.nr!==undefined)
        url+="/"+this.nr;
      this.$router.replace(url);
    },
    gotoNextWeek() {
      var iso=this.weekDate.plus({ days: 7 }).toISODate();
      var url=(this.baseUrl)+iso;
      if (this.nr!==undefined)
        url+="/"+this.nr;
      this.$router.replace(url);
    },
  },
  computed: {
  },
  watch: {
    date() {
      this.load();
    },
    nr() {
      this.load();
    }
  }
}
</script>

<style scoped>

</style>